import React, { useLayoutEffect, useRef, useState, useCallback } from 'react';
import * as _ from 'lodash';

import Portal from './Portal';
import { enableTouch } from '../../../utilities/tabletUtil';

const getCoordsDropdown = (decoratorRef, dropdownRef) => {
  const decoratorRect = decoratorRef.current.getBoundingClientRect();
  const dropdownRect = dropdownRef.current.getBoundingClientRect();
  let top;
  let left;
  if (decoratorRect.bottom + dropdownRect.height < window.innerHeight) {
    top = decoratorRect.bottom;
  } else if (decoratorRect.y - dropdownRect.height > 0) {
    top = decoratorRect.y - dropdownRect.height;
  } else {
    top = window.innerHeight - dropdownRect.height;
  }

  if (decoratorRect.x + dropdownRect.width < window.innerWidth) {
    left = decoratorRect.x;
  } else if (decoratorRect.right - dropdownRect.width > 0) {
    left = decoratorRect.right - dropdownRect.width;
  } else {
    left = 0;
  }
  return {
    top: top + window.scrollY,
    left: left + window.scrollX,
  };
};

export const DropdownPortal = props => {
  const {
    visible,
    decoratorRef,
    dropdownRef,
    onVisibleChange,
    children,
  } = props;
  const [coords, setCoords] = useState({
    left: 0,
    top: 0,
  });
  const containerRef = useRef(null);
  const eventName = !enableTouch() ? 'click' : 'touchstart';

  const handleClose = useCallback(
    () => {
      if (_.isFunction(onVisibleChange)) {
        onVisibleChange(false);
      }
    },
    [onVisibleChange]
  );

  const handleClickDocument = useCallback(
    e => {
      // コンポーネント内クリックの場合は無視する
      if (
        (containerRef.current && containerRef.current.contains(e.target)) ||
        (decoratorRef.current && decoratorRef.current.contains(e.target))
      ) {
        return;
      }
      handleClose();
    },
    [handleClose]
  );

  useLayoutEffect(
    () => {
      if (!visible) {
        return;
      }
      const coords = getCoordsDropdown(decoratorRef, dropdownRef);
      setCoords({
        left: coords.left,
        top: coords.top,
      });
    },
    [visible, decoratorRef, dropdownRef]
  );

  useLayoutEffect(
    () => {
      if (visible) {
        // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
        document.addEventListener(eventName, handleClickDocument, false);
        window.addEventListener('scroll', handleClose);
        const el = document.querySelector("[wj-part='root']");
        if (el) {
          el.addEventListener('scroll', handleClose);
        }
      }
      return () => {
        if (visible) {
          // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
          document.removeEventListener(eventName, handleClickDocument, false);
          window.removeEventListener('scroll', handleClose);
          const el = document.querySelector("[wj-part='root']");
          if (el) {
            el.removeEventListener('scroll', handleClose);
          }
        }
      };
    },
    [visible, eventName, handleClickDocument, handleClose]
  );

  return (
    <React.Fragment>
      {visible && (
        <Portal>
          <div
            id='form-dropdown-list'
            className='dropdown dropdown--dropdown-list show'
            ref={containerRef}
            style={{
              position: 'absolute',
              ...coords,
            }}
          >
            {children}
          </div>
        </Portal>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/dropdowns/portal/DropdownPortal.jsx